import ViewLoading from './view-loading'

export default ViewLoading



// WEBPACK FOOTER //
// ./src/views/my-components/view-loading/index.js